<template>
  <v-card :style="cardClass" class="ma-3">
    <chart
      type="donut"
      :data="details.data"
      :labels="details.labels"
      title="Network Health"
      elevation="0"
      width="auto"
      id="network-health"
      :loading="loadingStates.networkHealth"
      :options="details.options"
      dataPointSelection="handleClick"
    >
      <div class="d-flex flex-column" v-if="!loadingStates.networkHealth">
        <div
          class="d-flex justify-space-between align-center"
          style="width:95%;"
        >
          <h2 class="py-3 pl-4">
            Network Health
          </h2>
        </div>
      </div>
      <v-card-text
        v-if="!loadingStates.networkHealth"
        style="position: absolute; top: 45%;"
        class="text-center text-subtitle-2 font-weight-medium black--text"
      >
        <span id="total-devices-health">
          {{ totalDevices }}
        </span>
        <br />
        <span>
          Total Devices
        </span>
      </v-card-text>
      <info-tag label="CURRENT" />
    </chart>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import Chart from '@/components/charts/Chart';
import InfoTag from '@/components/app/InfoTag';
import { MobileView } from '@/mixins';

export default {
  components: {
    Chart,
    InfoTag,
  },
  mixins: [MobileView],

  computed: {
    ...mapGetters({
      details: 'home/getNetworkHealth',
      loadingStates: 'home/getGraphLoadingStates',
    }),
    totalDevices() {
      let total = 0;
      for (let i = 0; i < this.details.data.length; i += 1) {
        total += this.details.data[i];
      }
      total = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return total;
    },
    cardClass() {
      if (this.showMobileView) {
        return 'padding-bottom:10px;';
      }
      return 'overflow:hidden; min-height:100%; width:100%;';
    },
    chartWidth() {
      if (this.showMobileView) {
        return '';
      }
      return 'auto';
    },
  },
};
</script>

<style></style>
